import { api } from 'api';
import { ThunkAction } from 'store';

export const loadConfig =
  (): ThunkAction<Promise<void>> => async (dispatch) => {
    dispatch({ type: 'config/started' });

    try {
      const response = await fetch('/config.json').then((response) =>
        response.json()
      );
      window.deployment = response.deployment;
      window.urls = response.urls;
      api.defaults.baseURL = window.urls.api;
      dispatch({ type: 'config/finished', config: response });
    } catch {
      dispatch({ type: 'config/finished', error: 'Failed to load config' });
    }
  };
